import type { FunctionComponent } from 'react';
import Button from '../Button';
import * as styles from './AddAddressButton.module.scss';

type AddAddressButtonProps = {
  showMaxAddressLabel: boolean;
  handleClick: () => void;
};

const AddAddressButton: FunctionComponent<AddAddressButtonProps> = ({
  showMaxAddressLabel,
  handleClick,
}) => (
  <div className={styles.addMore} data-testid="add-address-button">
    {showMaxAddressLabel ? (
      <Button disabled>MAX 10 ADDRESSES</Button>
    ) : (
      <Button variation="black-outline" onClick={handleClick}>
        <i className="fal fa-plus" />
        ADD ADDRESS
      </Button>
    )}
  </div>
);

export default AddAddressButton;
